<template>
    <div id="forms-page" class="breadcrumb-content">
        <SidebarChild
            :items="menuItems"
            :selected-item="type"
            :focusActive="true"
            @selected="navigateTo"
            className="forms-menu"
        />
        <div class="container">
            <CreateForms v-if="type === 'form'" :formId="$route.params.formId" />
            <FormList v-if="type === 'list'" />
            <AutomationList type="event" module="form" v-if="type === 'form-automations'" />
        </div>
    </div>
</template>

<script>
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import { getOrUpdateFilters } from "../../../utils/persistenceStorage";
import CreateForms from "./Components/CreateForms.vue";
import FormList from "./Components/FormList.vue";
import { mapActions } from "vuex";
import AutomationList from "../Automation/pages/automations/AutomationList.vue";

const filters = getOrUpdateFilters("forms");

export default {
    name: "Home",
    components: {
        SidebarChild,
        CreateForms,
        FormList,
        AutomationList,
    },
    data() {
        return {
            type: this.$route.query.type || filters.type || "form",
            menuItems: [
                {
                    enabled: true,
                    key: "form",
                    label: this.$t("form.createForm"),
                    icon: {
                        type: "material-icons",
                        name: "add_circle",
                    },
                    route: { name: "form", query: { type: "form" } },
                },
                {
                    enabled: true,
                    key: "list",
                    label: this.$t("form.allForms"),
                    icon: {
                        type: "material-icons",
                        name: "document_scanner",
                    },
                    route: { name: "form", query: { type: "list" } },
                },
                {
                    enabled: true,
                    key: "form-automations",
                    label: "Form Automations",
                    icon: {
                        type: "component",
                        name: "AutomationIcon",
                        class: "myIcon",
                        style: { fill: "var(--color-icon-primary-default)" },
                    },
                    route: { name: "form", query: { type: "form-automations" } },
                },
            ],
        };
    },
    methods: {
        ...mapActions({
            getListForm: "forms/getListForm",
        }),
        navigateTo(item) {
            this.$router.push(item.route);
        },
    },
    watch: {
        "$route.query.type"(newType) {
            this.type = newType;
        },
        "$route.params.formId"(newFormId) {
            if (newFormId) {
                this.type = "form";
            }
        },
    },
    mounted() {
        this.getListForm();
    },
    created() {
        if (this.$route.params.formId) {
            this.type = "form";
        }
    },
};
</script>

<style lang="scss" scoped>
#forms-page {
    display: flex;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;

    .container {
        padding-right: 0px !important;
        padding-left: 0px !important;
        margin: 0px !important;

        .page-content {
            padding: 20px;
        }
    }
}
</style>

<style lang="scss">
.forms-menu {
    .sidebar-menu-item-text{
        max-width:unset !important;
        min-width:unset !important;
    }
}
</style>
